import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import OpdekdeurSelfInstallment from "features/option-controls/doors-self-installment/opdekdeur-self-installment";
import SchuifdeurSelfInstallment from "features/option-controls/doors-self-installment/schuifdeur-self-installment";
import TaatsdeurSelfInstallment from "features/option-controls/doors-self-installment/taatsdeur-self-installment";
import InstallmentOptionControls from "features/option-controls/installment-option-controls";
import OptionTemplate from "shared/ui/option-template";
import { OptionModalState } from "../option-modal";
import { DELIVERY_PRICES } from "shared/config/pricing";

export const DOORS_WITH_ENABLED_INSTALLMENT_TOGGLE = [
  "opdekdeur",
  "schuifdeur",
  "taatsdeur",
];

type ExtraOptionsBlockType = {
  setOptionModalState: (state: OptionModalState) => void;
};

export const SelfAssemblyBlock = ({
  setOptionModalState,
}: ExtraOptionsBlockType) => {
  const { selfAssembleDoorData, selectedDoor } =
    useConfigurationOptionsContext();

  if (!selectedDoor) return <></>;
  return (
    <>
      {DOORS_WITH_ENABLED_INSTALLMENT_TOGGLE.includes(selectedDoor.code) && (
        <OptionTemplate
          title="Montagewijze"
          description="Wil je het inmeten en monteren door GewoonGers laten verzorgen of ga je zelf aan de slag? Maak je keuze hier."
          onShowInfoClick={() =>
            setOptionModalState({
              isOpen: true,
              heading: "Montagewijze",
              description: `Kies je voor monteren door GewoonGers? Dan is de getoonde prijs altijd inclusief inmeetservice, transport en montage. Kies je ervoor om zelf in te meten en te monteren? Dan wordt er een korting berekend over de totaalprijs en betaal je €${DELIVERY_PRICES.SELF_ASSEMBLY},- bezorgkosten.`,
            })
          }
          testId="installment-option"
        >
          <InstallmentOptionControls />
        </OptionTemplate>
      )}

      {selfAssembleDoorData.selfAssembly === true &&
        DOORS_WITH_ENABLED_INSTALLMENT_TOGGLE.includes(selectedDoor.code) && (
          <OptionTemplate
            title="Afmeting deur"
            description="Om de afmetingen van jouw deur te kunnen bepalen hebben we de afmetingen van jouw deuropening nodig. Je hoeft geen rekening te houden met aftrekmaten of overlap. Die berekenen wij voor je."
            showInfo={false}
            testId="door-self-installment-option"
          >
            {selectedDoor.code === "taatsdeur" ? (
              <TaatsdeurSelfInstallment />
            ) : selectedDoor.code === "opdekdeur" ? (
              <OpdekdeurSelfInstallment
                onShowInfoClick={({ title, description }) =>
                  setOptionModalState({
                    isOpen: true,
                    heading: title,
                    description: description,
                  })
                }
              />
            ) : selectedDoor.code === "schuifdeur" ? (
              <SchuifdeurSelfInstallment
                onShowInfoClick={({ title, description }) =>
                  setOptionModalState({
                    isOpen: true,
                    heading: title,
                    description: description,
                  })
                }
              />
            ) : (
              <></>
            )}
          </OptionTemplate>
        )}
    </>
  );
};
